module.exports = __webpack_public_path__ + "2dd3dcb86c3b58be817e577ba9ab3247.MP3";